<template>
  <div class="class-charts">
    <!-- 分类得分情况 -->
    <div class="canvas-box" id="personalityHobby"></div>
  </div>
</template>
<script>
export default {
  props: ["model", "result1"],
  data() {
    return {
      bar: "",
      data1: [],
      personalityValues: [],
    };
  },
  mounted() {
    this.renderMap();
  },
  watch: {
    model(val) {
      if (val) {
        this.renderMap();
      }
    },
  },
  methods: {
    getEcharts3DBar(xAxisData, data, colorType) {
      var colorArr = [];
      if (colorType == "01") {
        colorArr = ["#1CAAA6", "#1CAAA6", "#A7E5E4"];
      } else {
        colorArr = ["#1CAAA6", "#1CAAA6", "#A7E5E4"];
      }
      var color = {
        type: "linear",
        x: 0,
        x2: 1,
        y: 0,
        y2: 0,
        colorStops: [
          {
            offset: 0,
            color: colorArr[0],
          },
          {
            offset: 0.5,
            color: colorArr[0],
          },
          {
            offset: 0.5,
            color: colorArr[1],
          },
          {
            offset: 1,
            color: colorArr[1],
          },
        ],
      };
      var barWidth = 20;
      var constData = [];
      var showData = [];

      data.filter(function (item) {
        if (item) {
          constData.push(1);
          showData.push(item);
        } else {
          constData.push(0);
          showData.push({
            value: 1,
            itemStyle: {
              normal: {
                borderColor: "rgba(0,0,0,0)",
                borderWidth: 2,
                color: "black",
              },
            },
          });
        }
      });

      return {
        title: {
          text: "偏好测评分析",
        },
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            var str = params[0].axisValue + "：";
            params.filter(function (item) {
              if (item.componentSubType == "bar") {
                str += "<br/>" + item.seriesName + "：" + item.value;
              }
            });
            return str;
          },
        },
        grid: {
          left: "3%", //图表距边框的距离
          right: "3%",
          top: "15%",
          bottom: "5%",
          containLabel: true,
        },

        xAxis: {
          type: "category",

          axisLabel: {
            clickable: true,
            interval: 0,
            fontWeight: "bold",
            fontSize: "10px",
            color: "black",
            textStyle: {
              color: "black",
            },
          },

          axisLine: { show: true }, // 轴线
          axisTick: { show: false }, // 刻度
          splitLine: { show: true }, // 分隔线
          data: [
            "a\n\n意志力",
            "b\n\n成就\n需求",
            "c\n\n统御\n需求",
            "d\n\n表现欲",
            "e\n\n合群性",
            "f\n\n亲和\n需求",
            "g\n\n喜新性",
            "h\n\n批判性",
            "i\n\n崇拜性",
            "j\n\n受役性",
          ],
        },
        yAxis: {
          max: 10,
          interval: 1,
          axisLine: { show: true }, // 轴线
          axisTick: { show: false }, // 刻度
          splitLine: { show: true }, // 分隔线
          type: "value",
          axisLabel: {
            clickable: true,
            interval: 0,
            fontWeight: "bold",
          },
        },
        series: [
          {
            label: {
              show: true, // 开启显示
              rotate: 360, // 旋转70度
              position: "top", // 在上方显示
              distance: 10, // 距离图形元素的距离。当 position 为字符描述值（如 'top'、'insideRight'）时候有效。
              verticalAlign: "middle",
              textStyle: {
                // 数值样式
                fontWeight: "bold",
                color: "#27BDB9",
                fontSize: 12,
              },
            },
            z: 1,
            name: "分数",
            type: "bar",
            barWidth: barWidth,
            barGap: "0%",
            data: data,
            itemStyle: {
              normal: {
                color: color,
              },
            },
          },
          {
            z: 2,
            name: "分数",
            type: "pictorialBar",
            data: constData,
            symbol: "diamond",
            symbolOffset: ["0%", "50%"],
            symbolSize: [barWidth, 10],
            itemStyle: {
              normal: {
                color: color,
              },
            },
            tooltip: {
              show: false,
            },
          },
          {
            z: 3,
            name: "数据",
            type: "pictorialBar",
            symbolPosition: "end",
            data: showData,
            symbol: "diamond",
            symbolOffset: ["0%", "-50%"],
            symbolSize: [barWidth - 4, (10 * (barWidth - 4)) / barWidth],
            itemStyle: {
              normal: {
                borderColor: colorArr[2],
                borderWidth: 2,
                color: colorArr[2],
              },
            },
            tooltip: {
              show: false,
            },
          },
        ],
      };
    },
    renderMap() {
      // this.personalityValues = this.model.personalityValues;
      // this.data1.push(
      //   this.personalityValues.a,
      //   this.personalityValues.b,
      //   this.personalityValues.c,
      //   this.personalityValues.d,
      //   this.personalityValues.e,
      //   this.personalityValues.f,
      //   this.personalityValues.g,
      //   this.personalityValues.h,
      //   this.personalityValues.i,
      //   this.personalityValues.j
      // );
      let myBarChart = (window.cc = this.$echarts.init(
        document.getElementById("personalityHobby"),
        null,
        {
          renderer: "svg",
        }
      ));

      myBarChart.setOption(
        this.getEcharts3DBar(
          ["服务1", "服务2", "服务3", "服务4", "服务5"],
          this.result1,
          "01"
        )
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.class-charts {
  position: relative;
  .canvas-box {
    width: 360px;
    height: 360px;
    margin: 0 0 0 120px;
    // margin: 10px auto 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dataView/echarts/personality/personalityHobby.vue